// composables/useB2CPKCE.ts
import { ref } from 'vue';

export function useB2CPKCE() {
    const codeVerifier = ref<string>('');

    // Base64-url encode
    const base64UrlEncode = (array: Uint8Array): string => {
        return btoa(String.fromCharCode(...array))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    };

    // Generate random code verifier
    const generateCodeVerifier = (length = 128): string => {
        const array = new Uint8Array(length);
        window.crypto.getRandomValues(array);
        return base64UrlEncode(array);
    };

    // Generate S256 code challenge
    const generateCodeChallenge = async (verifier: string): Promise<string> => {
        const encoder = new TextEncoder();
        const data = encoder.encode(verifier);
        const hash = await crypto.subtle.digest('SHA-256', data);
        return base64UrlEncode(new Uint8Array(hash));
    };

    // Trigger redirect to Azure B2C
    const redirectToB2C = async ({
        tenant,
        policy,
        clientId,
        redirectUri,
    }: {
        tenant: string;
        policy: string;
        clientId: string;
        redirectUri: string;
    }) => {
        codeVerifier.value = generateCodeVerifier();
        const codeChallenge = await generateCodeChallenge(codeVerifier.value);

        // Save codeVerifier for token exchange later
        sessionStorage.setItem('pkce_code_verifier', codeVerifier.value);

        const params = new URLSearchParams({
            client_id: clientId,
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: 'openid',
            prompt: 'login',
            code_challenge: codeChallenge,
            code_challenge_method: 'S256',
            p: policy,
            nonce: 'defaultNonce',
        });

        const authUrl = `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/oauth2/v2.0/authorize?${params.toString()}`;

        window.location.href = authUrl;
    };

    return {
        redirectToB2C,
        codeVerifier,
    };
}
